import { render } from "./QuestionMark.vue?vue&type=template&id=1bd377b4&scoped=true&ts=true"
import script from "./QuestionMark.vue?vue&type=script&lang=ts"
export * from "./QuestionMark.vue?vue&type=script&lang=ts"

import "./QuestionMark.vue?vue&type=style&index=0&id=1bd377b4&scoped=true&lang=css"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd377b4"]])

export default __exports__